import { render } from "./Invoice.vue?vue&type=template&id=0da3c34c&scoped=true&ts=true"
import script from "./Invoice.vue?vue&type=script&lang=ts"
export * from "./Invoice.vue?vue&type=script&lang=ts"

import "./Invoice.vue?vue&type=style&index=0&id=0da3c34c&scoped=true&lang=css"

import exportComponent from "/app/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0da3c34c"]])

export default __exports__